import { format } from "date-fns";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { HiOutlineCurrencyDollar } from "react-icons/hi";
import { RiShoppingCart2Line } from "react-icons/ri";
import { CheckBox } from "devextreme-react";

const Contractor = ({ contractor, isSelected, handleCustomerChecked, lastBookElementRef = null, setShowMessageCalculatePriceList, setCustIdToGeneratePriceList, setContractorHasPriceList }) => {
    let formattedDate = ""
    if (contractor.priceListGenerateDate !== "0001-01-01T00:00:00") {
        const dateObj = new Date(contractor.priceListGenerateDate)
        formattedDate = format(dateObj, "dd.MM.yyyy HH:mm")
    }

    const popover = formattedDate ?
        <Popover id="popover-basic">
            <Popover.Body className="text-center">
                <div className='d-flex flex-column'>
                    <span className='primary-accent-color-text'>Wywołaj natychmiastowe przeliczenie cennika</span>
                    <span className='primary-accent-color-text'>{`Data ostatniego cennika: ${formattedDate}`}</span>
                </div>

            </Popover.Body>
        </Popover>
        :
        <Popover id="popover-basic">
            <Popover.Body className="text-center">
                <span className='primary-accent-color-text'>Wywołaj natychmiastowe przeliczenie cennika</span>
            </Popover.Body>
        </Popover>

    const popoverBasketIcon = <Popover id="popover-basic">
        <Popover.Body className="text-center">
            <span className='primary-accent-color-text'>Kontrahent ma zapisany koszyk</span>
        </Popover.Body>
    </Popover>

    return (
        <tr id={contractor.custId} ref={lastBookElementRef}>
            <td>
                <CheckBox
                    className="custom-checkbox"
                    value={isSelected}
                    onValueChange={() => handleCustomerChecked(contractor)}
                />
            </td>
            <td>{contractor.name}</td>
            <td>{contractor.nip}</td>
            <td>{contractor.custAccount}</td>
            <td>{contractor.custNumber}</td>
            <td>{contractor.salesTeam}</td>
            <td>{contractor.address}</td>
            <td>
                <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover}>
                    <span>
                        <HiOutlineCurrencyDollar
                            size={28}
                            color="black"
                            cursor={'pointer'}
                            onClick={() => {
                                setCustIdToGeneratePriceList(contractor.custId)
                                setContractorHasPriceList(contractor.priceListGenerateDate === "0001-01-01T00:00:00" ? false : true)
                                setShowMessageCalculatePriceList(true)
                            }} />
                    </span>
                </OverlayTrigger>
            </td>
            <td>
                {contractor.hasSavedBasket &&
                    <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popoverBasketIcon}>
                        <div>
                            <RiShoppingCart2Line color="var(--primary)" size={28} />
                        </div>
                    </OverlayTrigger>}
            </td>
        </tr>
    )
};

export default Contractor;
